/* eslint-disable react/button-has-type */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFoundPage.scss';

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="not-found-container">
            <div className="not-found-content">
                <div className="not-found-code">
                    <span className="digit">4</span>
                    <span className="digit zero">0</span>
                    <span className="digit">4</span>
                </div>
                <div className="not-found-divider" />
                <h2 className="not-found-title">Không tìm thấy trang</h2>
                <p className="not-found-description">
                    Trang bạn đang tìm kiếm không tồn tại hoặc đã bị di chuyển.
                    <br />
                    Vui lòng kiểm tra lại đường dẫn hoặc quay về trang chủ.
                </p>
                <div className="not-found-actions">
                    <button className="btn-back" onClick={() => navigate(-1)}>
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M19 12H5" />
                            <path d="M12 19l-7-7 7-7" />
                        </svg>
                        Quay lại
                    </button>
                    <button className="btn-home" onClick={() => navigate('/')}>
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                            <polyline points="9 22 9 12 15 12 15 22" />
                        </svg>
                        Trang chủ
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;
